import Pdf from '../src/Pdf';
export default Pdf;
